import React from "react";
import { Image, Modal } from "react-bootstrap";
import VerifyIcon from "../../../assets/images/VerifyIcon.svg";

const VerifyPickUpConfirmationModal = (props) => {
  return (
    <Modal
      show={props.showVerifyPickup}
      onHide={props.handleCloseVerifyPickup}
      centered
      className="deliva-popup"
    >
      <Modal.Body>
        <div className="modal-content-wrap ">
          <div className="text-center">
            <Image src={VerifyIcon} className="img-fluid reject-img " />
            <h4 className=" mt-4 font-weight-normal mb-3 fs-24">
              {`Verify ${props.isDropOff ? "Drop Off" : "Pickup"} Confirmation`}
            </h4>
            <p className="color-grey">
              {`Are you sure you want to verify this ${props.isDropOff ? "Drop Off" : "Pickup"} package request?`}
            </p>
          </div>

          <div className="text-center mt-5">
            <button
              className="cancel-btn mr-4 min-w-80"
              onClick={props.handleCloseVerifyPickup}
            >
              No
            </button>
            <button className="b1-btn min-w-80" onClick={props.verifyPickup}>
              Yes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyPickUpConfirmationModal;
